// re.rejouis.fr — interrupteurs de fonctionnalités.

// Ajout d'un modèle absent du catalogue via le lien de la fiche neuve (écran
// Reference.jsx + fiches provisoires). MIS DE CÔTÉ le 2026-10-16 : on parie que
// les modèles intéressants sont déjà référencés, le reste passe en lot (évite
// d'ouvrir la porte à des modèles sans intérêt). Code conservé : remettre à true
// pour réafficher toutes les entrées (home, recherche, FAQ, écran Catalogue).
export const REFERENCEMENT_ACTIF = false;

// ?apercu=1 : re.rejouis affiché en fond de la heatmap du lab (iframe). Ni mesure
// PostHog, ni connexion automatique, ni pop-up d'avis : ce n'est pas une visite.
export const MODE_APERCU = (() => {
  try { return new URLSearchParams(window.location.search).has('apercu'); } catch { return false; }
})();
